<template>
  <div class="user-info-detail-wrapper">
    <div class="brief-info">
      <div class="user-info">
        <van-image
          round
          width="50"
          height="50"
          fit="cover"
          class="avatar"
          :src="value.avatar"
        />
        <span class="nickname">{{ value.nickname }}</span>
      </div>
      <!-- <van-icon name="setting-o" size="20" @click="handleUpdate" /> -->
    </div>
    <div class="balance-info">
      <div @click="handlePreview">
        <span class="dollar">￥</span>
        <span class="balance">{{ value.credit }}</span>
        <p class="title">账户余额</p>
      </div>
      <!-- <van-row class="keywords-wrapper">
        <van-col :span="8" @click="handlePreview">
          <p class="title">小时卡</p>
          <p class="value">{{ value.hours }}</p>
        </van-col>
        <van-col :span="8">
          <p class="title">游戏积分</p>
          <p class="value">{{ value.integral }}</p>
        </van-col>
        <van-col :span="8">
          <p class="title">推广码</p>
          <p class="value">{{ value.recommendation }}</p>
        </van-col>
      </van-row> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleUpdate() {
      this.$router.push({ name: 'user_info_detail' });
    },
    handlePreview() {
      this.$emit('preview');
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-detail-wrapper {
  background-image: url('../../../../assets/img/mytop.png');
  background-size: 120%;
  background-repeat: no-repeat;
  .brief-info {
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    .user-info {
      display: flex;
      align-items: center;
      .nickname {
        margin-left: 8px;
      }
    }
  }
  .balance-info {
    background-color: #fff;
    box-shadow: 0px 0px 20px 0px rgba(204, 204, 204, 0.5);
    border-radius: 6px;
    text-align: center;
    margin: 0 16px;
    padding: 36px;
    .dollar {
      font-size: 24px;
    }
    .balance {
      font-size: 46px;
    }
    .title {
      color: #828282;
      margin: 8px 0;
    }
    .keywords-wrapper {
      margin: 18px 0 0;
      display: flex;
      justify-content: space-around;
      text-align: center;
      .title {
        color: #828282;
        font-size: 14px;
      }
      .value {
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
